import { Container } from 'react-bootstrap'

const TourHeader = () => (
    <>
    <div className="section-discover-tour-heading">
        <Container>
            <h2 className="text-center">
                <strong>Ready to explore natural ways to feel healthier?</strong>
            </h2>
            <h5><strong>Hi, thanks for stopping by!</strong></h5>
            <p>If you'd like to create vitality for life using natural solutions take our quick tour below.</p>
            <p>Simply watch the short videos on this page and if you'd like to continue exploring, <br className="d-lg-block d-none"/>
                click the <em><strong className="text-continue-tour">"Continue Tour"</strong></em> button below.</p>
        </Container>
    </div>
    <style jsx global>{`

            .section-discover-tour-heading {
                font-size: 18px;
                line-height: 30px;
                color: #1b1b1b;
            }

            .section-discover-tour-heading .container {
                padding-top: 60px;
                padding-bottom: 60px;
            }

            .section-discover-tour-heading h2 {
                margin-bottom: 70px;
            }

            .section-discover-tour-heading .text-continue-tour {
                color: rgba(67,166,73,1.00);
            }

            @media (max-width: 767.98px) {

                .section-discover-tour-heading {
                    font-size: 14px;
                    line-height: normal;
                }

                .section-discover-tour-heading .container {
                    padding-bottom: 0px;
                }

                .section-discover-tour-heading h2 {
                    margin-top: 0;
                    font-size: 24px;
                }

                .section-discover-tour-heading h5 {
                    font-size: 18px;
                }

            }

        `}</style>
    </>
);

export default TourHeader;